const useGeraLink = () => {
    return (codigo : string, tipo : string, id?: number) : string => {
        switch(tipo) {
            case "C":
                return `/catalogo-componentes/${codigo}`;
            case "AM":
            case "AU":
            case "AH":
                return `/docs/${codigo}`;
            case "R":
                return id !== undefined ? `/catalogo-apis/${id}` : '#';
        }
        
        return '#';
    }
}

export default useGeraLink;